// extracted by mini-css-extract-plugin
export default {"input-shorter":"MetricInput_input-shorter__iNfQC","field-group":"MetricInput_field-group__P9alu"};